<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
    <p style="color: black"> กำลังโหลดข้อมูล... </p>
</ngx-spinner>
<div class="content-wrapper" style="min-height: 307px">
    <div class="card">
        <div class="card-header">
            <div class="row justify-content-md-center sticky">
                <div class="col-md-auto" style="text-align: center;">
                    <h2>ข้อมูลรถ </h2>
                </div>
                <div class="col-md-auto">
                    <!-- Nav tabs -->
                    <ul class="nav nav-pills nav-fill" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <a class="btn btn-outline-primary btn-lg" [ngClass]="{'active':cid == 1}"
                                (click)="cid=1;setDatakeep(settap);">รถบรรทุก</a>
                        </li>
                        <li class="nav-item">
                            <a class="btn btn-outline-warning btn-lg" [ngClass]="{'active':cid == 2}"
                                (click)="cid=2;">รถคีบ</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <!-- รถบรรทุก -->
    <div class="card  card-primary" [hidden]="cid!=1">
        <div class="card-header">
            <div class="card-title">
                <i class="fas fa-truck"></i> ฐานข้อมูลรถบรรทุก
            </div>
            <div class="card-tools">
                <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i>
                </button>
            </div>
        </div>
        <div class="card-body table-responsive p-2" style="border: 1px solid black;">
            <mat-progress-bar *ngIf="loading[1]" mode="indeterminate"></mat-progress-bar>
            <table id="datatable1" class="display table table-head-fixed table-bordered table-striped"
                style="width:100% ;text-align: center; ">
            </table>
        </div>
        <div class="card-body" *ngIf="false">
            <nav class="main-header navbar navbar-expand navbar-white navbar-light">
                <!-- Left navbar links -->
                <ul class="navbar-nav">
                    <li class="nav-item d-none d-sm-inline-block">
                    </li>
                </ul>
                <!-- Center navbar links -->
                <ul class="navbar-nav ml-auto">

                    <li class="nav-item d-none d-sm-inline-block">
                        <div>
                        </div>
                    </li>
                </ul>
                <!-- Right navbar links -->
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <div class="navbar-search-block">
                            <button class="btn" (click)="LoadTruckdata();">
                                <i class="fas fa-sync"></i>โหลดใหม่
                            </button>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="navbar-search-block">
                            <button [ngClass]="{ 'btn':true, 'active': settap == 1}"><i class="fas fa-plus"></i>
                                ในโซน</button>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="navbar-search-block">
                            <button [ngClass]="{ 'btn':true, 'active':settap == 2}"> <i class="fas fa-truck"></i>
                                ข้อมูลทั้งหมด</button>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="navbar-search-block">
                            <button [ngClass]="{ 'btn':true, 'active':settap == 3}"> <i class="fas fa-ban"></i>
                                รายการรถยกเลิก</button>
                        </div>
                    </li>
                </ul>
            </nav>
            <div class="row" [hidden]="addtruck">
                <!-- เพื่มข้อมูลรถบรรทุก -->
                <div class="col-md-3">
                    <div class="card card-primary">
                        <div class="card-header">
                            <h3 class="card-title"> <i class="fa fa-plus-circle">
                                </i>เพิ่มข้อมูลรถบรรทุก</h3>
                            <div class="card-tools">
                                <button type="button" class="btn btn-tool" data-card-widget="collapse"><i
                                        class="fas fa-minus"></i>
                                </button>
                            </div>
                            <!-- /.card-tools -->
                        </div>
                        <div class="card-body" *ngIf="setEdit">
                            <form [formGroup]="AddTruckdata">
                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon2">1.ทะเบียนรถ </span>
                                    <input type="text" class="form-control" formControlName="onetruckboardno"
                                        placeholder="เช่น 82-1234บร !ไม่ต้องเว้นวรรค"
                                        [ngClass]="{ 'is-invalid': submitted && form.onetruckboardno.errors }"
                                        maxlength="10" (change)="CheckBoardTruck();">
                                </div>
                                <p *ngIf="submitted && form.onetruckboardno.errors?.required" style="color: red;">
                                    กรุณาระบุ ทะเบียนรถ</p>
                                <p *ngIf="submitted && form.onetruckboardno.errors?.minlength" style="color: red;">
                                    กรุณาระบุ หมายเลขทะเบียนให้ถูกต้อง</p>
                                <p *ngIf="submitted && form.onetruckboardno.errors?.maxLength" style="color: red;">
                                    กรุณาระบุ หมายเลขทะเบียนให้ถูกต้อง</p>
                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon2">2.1.โควตาเจ้าของ
                                    </span>
                                    <input type="text" class="form-control" formControlName="twocodetruck"
                                        placeholder="เลขโควตา 5-6 หลัก" maxlength="6" (change)="CheckFarmer1();"
                                        [ngClass]="{ 'is-invalid': submitted && form.twocodetruck.errors }">
                                    <button class="btn btn-sm btn-warning"
                                        (click)="Autorunwithoutourfarmer()">ไม่มีโควตา</button>
                                </div>
                                <p *ngIf="submitted && form.twocodetruck.errors?.required" style="color: red;">
                                    กรุณาระบุ โควตาเจ้าของรถ</p>

                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon2">2.2.ชื่อเจ้าของ
                                    </span>
                                    <input type="text" class="form-control" formControlName="twopcodetruck"
                                        placeholder="เช่น นายสมยศ ปลดประจำการ"
                                        [ngClass]="{ 'is-invalid': submitted && form.twopcodetruck.errors }">
                                </div>
                                <p *ngIf="submitted && form.twocodetruck.errors?.required" style="color: red;">
                                    กรุณาระบุ ชื่อเจ้าของรถ</p>

                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon2">3.รหัสกลุ่ม</span>
                                    <input type="text" class="form-control" [(ngModel)]="gcode"
                                        formControlName="threegroupcode" disabled>
                                    <input type="text" class="form-control" formControlName="selectthreegroupcode"
                                        list="cutgroup" placeholder="เช่น เลขรหัส 6 หลัก" (change)="selectbycode(1);"
                                        [ngClass]="{ 'is-invalid': submitted && form.threegroupcode.errors }">
                                    <datalist id="cutgroup">
                                        <option *ngFor="let item of groupcutdata">{{item.groupcode}} |
                                            {{item.groupname}}</option>
                                    </datalist>
                                </div>
                                <p *ngIf="submitted && form.threegroupcode.errors?.required" style="color: red;">
                                    กรุณาระบุ รหัสกลุ่ม</p>

                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon2">4.โซน</span>

                                    <select class="form-control" formControlName="fourzonecode"
                                        [ngClass]="{ 'is-invalid': submitted && form.fourzonecode.errors }">
                                        <option value="0" disabled>กรุณาเลือก</option>
                                        <option *ngFor="let item of zonecode" [ngValue]="item.supzone">
                                            {{item.supzone}} | {{item.zonename}}</option>

                                    </select>
                                </div>
                                <p *ngIf="submitted && form.fourzonecode.errors?.required" style="color: red;">
                                    กรุณาระบุ โซน</p>


                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon2">5.ประเภทรถ</span>
                                    <!-- <input type="text" class="form-control" formControlName="fivetrucktype" placeholder=""
                                            [ngClass]="{ 'is-invalid': submitted && form.fivetrucktype.errors }"> -->

                                    <select class="form-control" formControlName="fivetrucktype"
                                        [ngClass]="{ 'is-invalid': submitted && form.fivetrucktype.errors }">
                                        <option value="00" selected disabled>ประเภทรถ </option>
                                        <option *ngFor="let item of listtrucktype" [ngValue]="item.type">
                                            {{item.type}} | {{item.typename}}</option>
                                    </select>
                                </div>
                                <p *ngIf="submitted && form.fivetrucktype.errors?.required" style="color: red;">
                                    กรุณาเลือก ประเภทรถ</p>

                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon2">6.สมาร์ทโฟน</span>
                                    <select class="form-control" formControlName="sixsmartphone"
                                        [ngClass]="{ 'is-invalid': submitted && form.sixsmartphone.errors }">
                                        <option value="0" disabled>กรุณาเลือก</option>
                                        <option value="1">มี</option>
                                        <option value="0">ไม่มี</option>
                                    </select>

                                </div>
                                <p *ngIf="form.sixsmartphone.errors?.required" style="color: red;">
                                    กรุณาเลือก
                                    สมาร์ทโฟน</p>


                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon2">7.ติดGPS </span>
                                    <select class="form-control" formControlName="sevengps"
                                        [ngClass]="{ 'is-invalid': submitted && form.sevengps.errors }">
                                        <option value="0" disabled>กรุณาเลือก</option>
                                        <option value="1">มี</option>
                                        <option value="0">ไม่มี</option>
                                    </select>

                                </div>
                                <p *ngIf="form.sevengps.errors?.required" style="color: red;">
                                    กรุณาเลือก GPS
                                </p>

                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon2">8.รหัสบัตร </span>
                                    <input type="text" class="form-control" formControlName="carduid"
                                        placeholder="รหัสบัตร" onfocus="this.value=''" maxlength="8"
                                        onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57)">

                                </div>
                                <div class="input-group mb-3">
                                    <div class="input-group-text">
                                        <input class="form-check-input mt-0" type="checkbox" formControlName="trust"
                                            aria-label="Checkbox for following text input" (click)="ToggleTrust()">
                                    </div>
                                    <span class="input-group-text" id="basic-addon2">
                                        ยืนยันข้อมูลถูกต้อง
                                    </span>
                                    <button class="btn btn-info" [disabled]="enable" (click)="SaveNewTruck()">
                                        <i class="far fa-save"></i> บันทึกข้อมูล</button>
                                    <button class="btn btn-info" (click)="AddTruckdata.reset()">ล้างข้อมูล</button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>

                <!-- ตารางแสดงข้อมูลรถ -->
                <div class="col-md-9">
                    <div class="card">
                        <div class="card-body">

                            <table #truckTable
                                class="table table-hover table-head-fixed text-nowrap table-bordered border-primary">
                                <thead>
                                    <tr>
                                        <th>รหัสรถ</th>
                                        <th>โซน</th>
                                        <th>โควตา</th>
                                        <th>ชื่อ-สกุล</th>
                                        <th>ทะเบียนรถ</th>
                                        <th>กลุ่ม</th>
                                        <th>รหัสบัตร</th>
                                        <th>ประเภทรถ</th>
                                        <th>Lastupdate</th>
                                        <th> แก้ไข/ยกเลิก</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of Dataalltruck">
                                        <td>{{item.TRUCK_NO}}</td>
                                        <td>{{item.SUPZONE}}</td>
                                        <td>{{item.OWNCODE}}</td>
                                        <td>{{item.FMname}}</td>
                                        <td>{{item.REGTRUCK}}</td>

                                        <td>{{item.GROUPCODE}}</td>
                                        <td>{{item.carduid}}</td>
                                        <td>{{item.TRUCK_TYPE}} - {{item.TRUCK_TYPENAME}}</td>
                                        <td>{{item.Lastupdate|date}}</td>
                                        <td>
                                            &nbsp;
                                            <button class="btn btn-warning btn-sm" data-bs-toggle="modal" disabled
                                                data-bs-target="#EditData" *ngIf="settap == 1"
                                                (click)="OnetoEdit(item)">
                                                <i class="fas fa-edit"></i>
                                            </button>&nbsp;
                                            <button class="btn btn-danger btn-sm" *ngIf="settap == 1" disabled
                                                (click)="CancleTruck(item.TRUCK_NO)">
                                                <i class="fas fa-window-close"></i>
                                            </button>
                                            <button class="btn btn-secondary" data-bs-toggle="modal" disabled
                                                data-bs-target="#restore" *ngIf="settap == 3&&setEdit"
                                                (click)="Oneretruck(item.TRUCK_NO)">
                                                <i class="fas fa-trash-restore"></i>
                                            </button>&nbsp;

                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- รถบรรทุก -->

    <div class="card card-warning" [hidden]="cid!=2">
        <div class="card-header">
            <div class="card-title">
                <i class="fas fa-trailer"></i> ฐานข้อมูลรถคีบ
            </div>
            <div class="card-tools">
                <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus"></i>
                </button>
            </div>
            <!-- /.card-tools -->
        </div>
        <div class="card-body table-responsive p-2" style="border: 1px solid black;">
            <mat-progress-bar *ngIf="loading[2]" mode="indeterminate"></mat-progress-bar>
            <table id="datatable2" class="display table table-head-fixed table-bordered table-striped"
                style="width:100% ;text-align: center; ">
            </table>
        </div>

        <div class="card-body" *ngIf="false">
            <nav class="main-header navbar navbar-expand navbar-white navbar-light">
                <!-- Left navbar links -->
                <ul class="navbar-nav">
                    <li class="nav-item d-none d-sm-inline-block">
                    </li>
                </ul>
                <!-- Center navbar links -->
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item d-none d-sm-inline-block">
                        <div>
                        </div>
                    </li>

                </ul>
                <!-- Right navbar links -->
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <div class="navbar-search-block">
                            <button class="btn" (click)="LoadAllKeep();">
                                <i class="fas fa-sync"></i>โหลดใหม่
                            </button>
                        </div>
                    </li>
                    <li class="nav-item" (click)="setDatakeep(1);">
                        <div class="navbar-search-block">
                            <button [ngClass]="{ 'btn':true, 'active': setKtap == 1 }"><i class="fas fa-plus"></i>
                                ในโซน</button>
                        </div>
                    </li>
                    <li class="nav-item" (click)="setDatakeep(2);">
                        <div class="navbar-search-block">
                            <button [ngClass]="{ 'btn':true, 'active':setKtap == 2}"> <i class="fas fa-trailer"></i>
                                ข้อมูลทั้งหมด</button>
                        </div>
                    </li>
                </ul>
            </nav>
            <div class="row" [hidden]="addkeep">
                <div class="col-md-auto">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title"> <i class="fa fa-plus-circle"> </i>เพิ่มข้อมูลรถคีบ
                            </h3>
                            <div class="card-tools">
                                <button type="button" class="btn btn-tool" data-card-widget="collapse"><i
                                        class="fas fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card-body">
                            <form [formGroup]="AddKeepdata">
                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon2">1.1 โควตาเจ้าของรถ
                                    </span>
                                    <input type="text" class="form-control" id="codefm" formControlName="onefmcode"
                                        placeholder="เลขโควตา 5หรือ6 หลัก"
                                        [ngClass]="{ 'is-invalid': submitted && keepform.onefmcode.errors }"
                                        maxlength="10" (change)="LoadFarmerbycode();">
                                </div>

                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon2">1.2 ชื่อเจ้าของรถ
                                    </span>
                                    <input type="text" class="form-control" formControlName="onefmname" placeholder=""
                                        (change)="CheckFarmer1();"
                                        [ngClass]="{ 'is-invalid': submitted && form.twocodetruck.errors }">
                                </div>
                                <p *ngIf="submitted && form.twocodetruck.errors?.required" style="color: red;">
                                    กรุณาระบุ โควตาเจ้าของรถ</p>

                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon2">2. รหัสกลุ่ม
                                    </span>
                                    <input type="text" class="form-control" formControlName="twogroupcode"
                                        [ngClass]="{ 'is-invalid': submitted && keepform.twogroupcode.errors }"
                                        disabled>
                                    <input type="text" class="form-control" formControlName="selecttwogroupcode"
                                        list="cutgroup" placeholder="เช่น เลขรหัส 6 หลัก" (change)="selectbycode(3);"
                                        [ngClass]="{ 'is-invalid': submitted && form.threegroupcode.errors }">
                                    <datalist id="cutgroup">
                                        <option *ngFor="let item of groupcutdata">{{item.groupcode}} |
                                            {{item.groupname}}</option>
                                    </datalist>


                                </div>
                                <p *ngIf="submitted && keepform.twogroupcode.errors?.required" style="color: red;">
                                    กรุณาระบุ รหัสกลุ่ม</p>

                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon2">3.โซน</span>
                                    <select class="form-control" formControlName="threezonecode"
                                        [ngClass]="{ 'is-invalid': submitted && keepform.threezonecode.errors }">
                                        <option value="0" disabled>กรุณาเลือก</option>
                                        <option *ngFor="let item of zonecode" [ngValue]="item.supzone">
                                            {{item.supzone}} | {{item.zonename}}</option>
                                    </select>
                                </div>
                                <p *ngIf="submitted && keepform.threezonecode.errors?.required" style="color: red;">
                                    กรุณาระบุ โซน</p>

                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon2">4.ชื่อคนขับ</span>
                                    <input class="form-control" formControlName="fourdrivername"
                                        [ngClass]="{ 'is-invalid': submitted && keepform.fourdrivername.errors }">

                                </div>
                                <p *ngIf="submitted && keepform.fourdrivername.errors?.required" style="color: red;">
                                    กรุณาระบุ ชื่อคนขับ</p>


                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon2">5.เบอร์โทรคนขับ</span>

                                    <input type="text" class="form-control" formControlName="fivedriverphone"
                                        [ngClass]="{ 'is-invalid': submitted && keepform.fivedriverphone.errors }">


                                </div>
                                <p *ngIf="submitted && keepform.fivetrucktype.errors?.required" style="color: red;">
                                    กรุณาระบุ เบอร์โทรคนขับ</p>


                                <div class="input-group mb-3">
                                    <div class="input-group-text">
                                        <input class="form-check-input mt-0" type="checkbox" formControlName="trust"
                                            aria-label="Checkbox for following text input" (click)="ToggleTrust()">
                                    </div>
                                    <span class="input-group-text" id="basic-addon2">
                                        ยืนยันข้อมูลถูกต้อง
                                    </span>
                                    <button class="btn btn-info" [disabled]="enable" (click)="SaveNewKeep();">
                                        <i class="far fa-save"></i> บันทึกข้อมูล</button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>

                <div class="col-md">
                    <div class="card">
                        <div class="card-body">
                            <table #keepTable
                                class="table table-hover table-head-fixed text-nowrap table-bordered border-primary">
                                <thead>
                                    <tr>
                                        <th scope="col">รหัสรถ </th>
                                        <th scope="col"> โควตา </th>
                                        <th scope="col"> ชื่อ-สกุล </th>
                                        <th scope="col"> กลุ่ม </th>
                                        <th scope="col"> โซน </th>
                                        <th scope="col"> lastupdate </th>
                                        <th scope="col"> Action </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let keep of Dataallkeep">
                                        <td>{{keep.Keep_no}}</td>
                                        <td>{{keep.Owncode_keep}}</td>
                                        <td>{{keep.Fmname}}</td>
                                        <td>{{keep.Groupcode}}</td>
                                        <td>{{keep.Supzone}}</td>
                                        <td>{{keep.Lastupdate|date}}</td>
                                        <td>
                                            <button class="btn btn-info btn-sm" *ngIf="setKtap==1"
                                                data-bs-toggle="modal" data-bs-target="#KeepEdit"
                                                (click)="OneKeepEdit(keep.Keep_no)">
                                                <i class="far fa-edit"></i>
                                            </button>
                                            <button class="btn btn-danger btn-sm" *ngIf="setKtap==1"
                                                (click)="CancleKeep(keep.Keep_no);">
                                                <i class="far fa-window-close"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <!-- Modal แก้ไขข้อมูลรถบรรทุก -->
    <div class="modal fade" id="EditData" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content" *ngIf="onetruck2">
                <div class="modal-header bg-yellow">
                    <h3>แก้ไขข้อมูลรถบรรทุก {{onetruck2.TRUCK_NO}}</h3>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <table>
                        <tr>
                            <td>1.ทะเบียนรถ</td>
                            <td><input type="text" class="form-control" [(ngModel)]="onetruck2.REGTRUCK">
                            </td>
                            <td>{{onetruck.REGTRUCK}}</td>
                        </tr>
                        <tr>
                            <td>2.1 โควตาเจ้าของรถ</td>
                            <td><input type="text" class="form-control" [(ngModel)]="onetruck2.OWNCODE">
                            </td>
                            <td>{{onetruck.OWNCODE}}</td>
                        </tr>
                        <tr>
                            <td>2.2 ชื่อเจ้าของรถ</td>
                            <td><input type="text" class="form-control" [(ngModel)]="onetruck2.FMname"
                                    placeholder="เช่น นายสมยศ ปลดประจำการ"></td>
                            <td>{{onetruck.FMname}}</td>
                        </tr>
                        <tr>
                            <td>3.รหัสกลุ่ม</td>
                            <td><input type="text" class="form-control" [(ngModel)]="onetruck2.GROUPCODE"
                                    placeholder="เช่น เลขรหัส 6 หลัก">
                            </td>
                            <td>{{onetruck.GROUPCODE}}</td>
                        </tr>
                        <tr>
                            <td>4.โซน</td>
                            <td><select class="form-control" [(ngModel)]="onetruck2.SUPZONE">
                                    <option value="0" disabled>กรุณาเลือก</option>
                                    <option *ngFor="let item of zonecode" [ngValue]="item.supzone">
                                        {{item.supzone}} | {{item.zonename}}</option>
                                </select>
                            </td>
                            <td>{{onetruck.SUPZONE}}</td>
                        </tr>
                        <tr>
                            <td>5.ประเภทรถ</td>
                            <td><select class="form-select" [(ngModel)]="onetruck2.TRUCK_TYPE" disabled>
                                    <option value="" selected disabled>ประเภทรถ </option>
                                    <option *ngFor="let item of listtrucktype" [ngValue]="item.type">
                                        {{item.type}} | {{item.typename}}</option>
                                </select>
                            <td>{{onetruck.TRUCK_TYPE}}</td>
                        </tr>
                        <tr style="text-align: center;">
                            <td>
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            </td>
                            <td><button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                                    (click)="UpdateDataTruck(onetruck2)">บันทึก</button></td>
                            <td></td>
                        </tr>
                    </table>
                </div>
                <!--
                <div class="modal-footer" *ngFor="let item of oneedittruck">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                        (click)="UpdateDataTruck(item.TRUCK_NO)">บันทึก</button>
                </div>-->
            </div>
        </div>
    </div>
    <!-- Modal แก้ไขข้อมูลรถบรรทุก -->

    <div class="modal fade" id="CancleData" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">ยกเลิกข้อมูล</h5>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    ...
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary">Save changes</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->



    <!-- Modal แก้ไขข้อมูลรถคีบ -->
    <div class="modal fade" id="KeepEdit" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header bg-yellow">
                    <h1>แก้ไขข้อมูลรถคีบ </h1>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form [formGroup]="EditKeepdata">
                        <div class="input-group mb-3">
                            <span class="input-group-text" id="basic-addon2">1.1 โควตาเจ้าของรถ </span>
                            <input type="text" class="form-control" id="codefm" formControlName="oneeditfmcode"
                                placeholder="เลขโควตา 5หรือ6 หลัก"
                                [ngClass]="{ 'is-invalid': submitted && keepform.onefmcode.errors }" maxlength="10"
                                (change)="LoadFarmerbycode2();">
                        </div>

                        <div class="input-group mb-3">
                            <span class="input-group-text" id="basic-addon2">1.2 ชื่อเจ้าของรถ </span>
                            <input type="text" class="form-control" formControlName="oneeditfmname" placeholder=""
                                [ngClass]="{ 'is-invalid': submitted && form.twocodetruck.errors }">
                        </div>
                        <p *ngIf="submitted && form.twocodetruck.errors?.required" style="color: red;">
                            กรุณาระบุ
                            โควตาเจ้าของรถ</p>

                        <div class="input-group mb-3">
                            <span class="input-group-text" id="basic-addon2">2. รหัสกลุ่ม </span>
                            <input type="text" class="form-control" formControlName="twoeditgroupcode"
                                [ngClass]="{ 'is-invalid': submitted && keepform.twogroupcode.errors }" disabled>
                            <input type="text" class="form-control" formControlName="trust" list="cutgroup"
                                placeholder="เช่น เลขรหัส 6 หลัก" (change)="selectbycode(4);"
                                [ngClass]="{ 'is-invalid': submitted && form.threegroupcode.errors }">
                            <datalist id="cutgroup">
                                <option *ngFor="let item of groupcutdata">{{item.groupcode}} |
                                    {{item.groupname}}
                                </option>
                            </datalist>


                        </div>
                        <p *ngIf="submitted && keepform.twogroupcode.errors?.required" style="color: red;">
                            กรุณาระบุ
                            รหัสกลุ่ม</p>

                        <div class="input-group mb-3">
                            <span class="input-group-text" id="basic-addon2">3.โซน</span>
                            <select class="form-control" formControlName="threeeditzonecode"
                                [ngClass]="{ 'is-invalid': submitted && keepform.threezonecode.errors }">
                                <option value="0" disabled>กรุณาเลือก</option>
                                <option *ngFor="let item of zonecode" [ngValue]="item.supzone">
                                    {{item.supzone}} | {{item.zonename}}</option>
                            </select>
                        </div>
                        <p *ngIf="submitted && keepform.threegroupcode.errors?.required" style="color: red;">
                            กรุณาระบุ
                            โซน</p>

                        <div class="input-group mb-3">
                            <span class="input-group-text" id="basic-addon2">4.ชื่อคนขับ</span>
                            <input class="form-control" formControlName="foureditdrivername"
                                [ngClass]="{ 'is-invalid': submitted && keepform.fourdrivername.errors }">

                        </div>
                        <p *ngIf="submitted && keepform.fourdrivername.errors?.required" style="color: red;">
                            กรุณาระบุ
                            ชื่อคนขับ</p>


                        <div class="input-group mb-3">
                            <span class="input-group-text" id="basic-addon2">5.เบอร์โทรคนขับ</span>

                            <input type="text" class="form-control" formControlName="fiveeditdriverphone"
                                [ngClass]="{ 'is-invalid': submitted && keepform.fivedriverphone.errors }">


                        </div>
                        <p *ngIf="submitted && keepform.fivetrucktype.errors?.required" style="color: red;">
                            กรุณาระบุ
                            เบอร์โทรคนขับ</p>

                    </form>
                </div>
                <div class="modal-footer" *ngFor="let item of onekeepdata">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                        (click)="Reset();">Close</button>
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                        (click)="UpdateDataKeep(item.Keep_no)">บันทึก</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal แก้ไขข้อมูลรถคีบ -->

    <!-- รายการรถที่มีแล้วทะเบียนซ้ำ -->
    <div class="modal fade" id="Listtruck" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header bg-danger">
                    <h1>รายการทะเบียนที่ตรงกัน</h1>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                </div>
                <div class="modal-footer" *ngFor="let item of onekeepdata">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                </div>
            </div>
        </div>
    </div>
    <!-- รายการรถที่มีแล้วทะเบียนซ้ำ -->

    <!-- คืนค่ารถบรรทุก -->
    <div class="modal fade" id="restore" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header bg-danger">
                    <h1>รายการนำรถกลับมาใช้</h1>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" [formGroup]="AddTruckdata">
                    <p *ngFor="let item of oneretruck">
                        <label>รหัสรถ : {{item.TRUCK_NO}} </label> <br>
                        <label> เจ้าของรถ : {{item.OWNCODE}} </label> <br>
                        <label> ชื่อ-สกุล : {{item.FMname}} </label>
                    </p>
                    <div class="input-group mb-3">

                        <span class="input-group-text" id="basic-addon2"> ประเภทรถ</span>
                        <!-- <input type="text" class="form-control" formControlName="fivetrucktype" placeholder=""
                        [ngClass]="{ 'is-invalid': submitted && form.fivetrucktype.errors }"> -->

                        <select class="form-control" formControlName="fivetrucktype"
                            [ngClass]="{ 'is-invalid': submitted && form.fivetrucktype.errors }">
                            <option value="00" selected disabled>ประเภทรถ </option>
                            <option *ngFor="let item of listtrucktype" [ngValue]="item.type">
                                {{item.type}} | {{item.typename}}</option>
                        </select>
                    </div>
                </div>
                <div class="modal-footer" *ngFor="let item of oneretruck">
                    <button type="button" class="btn btn-secondary" (click)="Restoretruck(item.TRUCK_NO)"
                        data-bs-dismiss="modal">บันทึก</button>
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!-- คืนค่ารถบรรทุก -->
</div>
<!-- content-wrapper -->
<app-footer></app-footer>